import React from 'react';

import styles from '~/components/lawns/digital-soil-test/digital-soil-test.module.scss';

const DigitalSoilTestSubheading = ({ children, Tag = 'h3' }) => (
  <Tag className={styles.dstHeading}>
    <span className={styles.thickUnderline}>{children}</span>
  </Tag>
);

export default DigitalSoilTestSubheading;
